import {
  COMMON_GET_PDF_SAVING_PLAN_BEGIN,
  COMMON_GET_PDF_SAVING_PLAN_SUCCESS,
  COMMON_GET_PDF_SAVING_PLAN_FAILURE,
  COMMON_GET_PDF_SAVING_PLAN_DISMISS_ERROR,
} from './constants';
import axios from 'axios'
import { SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT } from 'cfgCommon/endpoints'

export function getPdfSavingPlan(id_subscription) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: COMMON_GET_PDF_SAVING_PLAN_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {

      const doRequest = axios(SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT+`/generar-pdf-plan-de-ahorro/${id_subscription}`,{
        method: 'GET',
        responseType: 'text/html'
      })
      doRequest.then(
        (res) => {
          dispatch({
            type: COMMON_GET_PDF_SAVING_PLAN_SUCCESS,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: COMMON_GET_PDF_SAVING_PLAN_FAILURE,
            data: { error: err.message },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetPdfSavingPlanError() {
  return {
    type: COMMON_GET_PDF_SAVING_PLAN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_GET_PDF_SAVING_PLAN_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPdfSavingPlanPending: true,
        getPdfSavingPlanError: null,
      };

    case COMMON_GET_PDF_SAVING_PLAN_SUCCESS:
      // The request is success
      return {
        ...state,
        getPdfSavingPlanPending: false,
        getPdfSavingPlanError: null,
      };

    case COMMON_GET_PDF_SAVING_PLAN_FAILURE:
      // The request is failed
      return {
        ...state,
        getPdfSavingPlanPending: false,
        getPdfSavingPlanError: action.data.error,
      };

    case COMMON_GET_PDF_SAVING_PLAN_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getPdfSavingPlanError: null,
      };

    default:
      return state;
  }
}
